export const getEntitiesByCompanyNameQuery = (companyName: string) => {
    return `
    {
      entitiesByCompanyName(companyName:"${companyName}"){
        id
        name
        hasRuleCustomization
        abbreviation
        location
        onboardingDate
        createdAt
        updatedAt
        company{
          id
          name
        }
        audit(sorting: DESC) {
          id
          year
        }
        entitySystems(sorting: ASC) {
          id
          hasEtlCustomization
          system {
            id
            name
          }
        }
        entityContext{
          id
          bucketName
          domains
          whitelistDepartments
          whitelistApprovers
          keyFinancialFoldersList
          keyFinancialFoldersWhitelistDepartments
          keyFinancialFoldersWhitelistUsers
          keyFinancialFoldersWhitelistDepartmentsColumnName
          mongodbCredentials
          githubRepos
          gitlabProjects
          hrAdminGroups
          jiraProjects
          ITEmail
          flowDependency
          environmentsUrl
          jobsBlacklistUsers
          jobsBlacklistRoles
          administrationActivitiesAdminsWhitelist
          administrationActivitiesCriticalActivitiesBlacklist
          weekendDays
          createdAt
          updatedAt
        }
      }
    }
    `
}
